'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _jobs = require('./jobs.component');

var _jobs2 = _interopRequireDefault(_jobs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var jobsModule = _angular2.default.module('app.containers.jobs', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('jobs', {
    url: '/jobs',
    template: '<jobs></jobs>'
  });
}).component('jobs', _jobs2.default);

exports.default = jobsModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/jobs/jobs.js
 **/